import { httpClient } from "@api/httpClient";

export async function exportBusinessUnitsToExcel(isActive: number) {
  try {
    await httpClient
      .get(`/api/v1/business-units/export?isActive=${isActive}`, {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/octet-stream",
        },
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        var currDate = new Date().toLocaleString().replace(",", "");
        link.setAttribute(
          "download",
          "GEARSBUSINESSUNITS_" + currDate + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
      });
  } catch (error) {
    throw error;
  }
}
